/**
 * FaceSwap 选项配置 - 国际化版本
 * 使用翻译键引用，支持多语言
 */

export const cameraOptions = [
  {
    name: "aiWorkbench.faceSwap.categories.photography",
    key: "photography",
    children: [
      {
        name: "aiWorkbench.faceSwapeCameraOptions.photography.cameraType.label",
        key: "camera_type",
        options: [
          { key: "Full-frame DSLR", label: "aiWorkbench.faceSwapeCameraOptions.photography.cameraType.options.fullFrameDslr" },
          { key: "APS-C Camera", label: "aiWorkbench.faceSwapeCameraOptions.photography.cameraType.options.apsC" },
          { key: "Mirrorless Camera", label: "aiWorkbench.faceSwapeCameraOptions.photography.cameraType.options.mirrorless" },
          { key: "Medium Format Camera", label: "aiWorkbench.faceSwapeCameraOptions.photography.cameraType.options.mediumFormat" },
          { key: "Point-and-shoot Camera", label: "aiWorkbench.faceSwapeCameraOptions.photography.cameraType.options.pointAndShoot" },
          { key: "Phone Camera", label: "aiWorkbench.faceSwapeCameraOptions.photography.cameraType.options.phone" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeCameraOptions.photography.lensType.label",
        key: "lens_type",
        options: [
          { key: "Standard lens (50mm f/1.8)", label: "aiWorkbench.faceSwapeCameraOptions.photography.lensType.options.standard" },
          { key: "Wide-angle lens (35mm, 24mm)", label: "aiWorkbench.faceSwapeCameraOptions.photography.lensType.options.wideAngle" },
          { key: "Medium telephoto lens (85mm, 105mm)", label: "aiWorkbench.faceSwapeCameraOptions.photography.lensType.options.mediumTelephoto" },
          { key: "Telephoto lens (200mm, 300mm)", label: "aiWorkbench.faceSwapeCameraOptions.photography.lensType.options.telephoto" },
          { key: "Macro lens", label: "aiWorkbench.faceSwapeCameraOptions.photography.lensType.options.macro" },
          { key: "Fisheye lens", label: "aiWorkbench.faceSwapeCameraOptions.photography.lensType.options.fisheye" },
          { key: "Zoom lens (24-70mm, 70-200mm)", label: "aiWorkbench.faceSwapeCameraOptions.photography.lensType.options.zoom" },
          { key: "Prime lens (35mm, 50mm, 85mm)", label: "aiWorkbench.faceSwapeCameraOptions.photography.lensType.options.prime" },
          { key: "Large aperture lens (f/1.2, f/1.4)", label: "aiWorkbench.faceSwapeCameraOptions.photography.lensType.options.largeAperture" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeCameraOptions.photography.focalLength.label",
        key: "focal_length",
        options: [
          { key: "Ultra-wide angle (10mm-24mm)", label: "aiWorkbench.faceSwapeCameraOptions.photography.focalLength.options.ultraWide" },
          { key: "Wide angle (35mm, 50mm)", label: "aiWorkbench.faceSwapeCameraOptions.photography.focalLength.options.wide" },
          { key: "Standard (85mm, 105mm)", label: "aiWorkbench.faceSwapeCameraOptions.photography.focalLength.options.standard" },
          { key: "Telephoto (200mm, 300mm)", label: "aiWorkbench.faceSwapeCameraOptions.photography.focalLength.options.telephoto" },
          { key: "Super-telephoto (400mm, 600mm)", label: "aiWorkbench.faceSwapeCameraOptions.photography.focalLength.options.superTelephoto" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeCameraOptions.photography.aperture.label",
        key: "aperture",
        options: [
          { key: "Large aperture (f/1.2, f/1.4)", label: "aiWorkbench.faceSwapeCameraOptions.photography.aperture.options.large" },
          { key: "Medium aperture (f/2.8, f/3.5)", label: "aiWorkbench.faceSwapeCameraOptions.photography.aperture.options.medium" },
          { key: "Small aperture (f/8, f/11)", label: "aiWorkbench.faceSwapeCameraOptions.photography.aperture.options.small" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeCameraOptions.photography.shutterSpeed.label",
        key: "shutter_speed",
        options: [
          { key: "Fast shutter (1/1000s, 1/500s)", label: "aiWorkbench.faceSwapeCameraOptions.photography.shutterSpeed.options.fast" },
          { key: "Medium shutter (1/250s, 1/125s)", label: "aiWorkbench.faceSwapeCameraOptions.photography.shutterSpeed.options.medium" },
          { key: "Slow shutter (1/60s, 1/30s)", label: "aiWorkbench.faceSwapeCameraOptions.photography.shutterSpeed.options.slow" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeCameraOptions.photography.iso.label",
        key: "iso",
        options: [
          { key: "Low ISO (100-400)", label: "aiWorkbench.faceSwapeCameraOptions.photography.iso.options.low" },
          { key: "Medium ISO (800-1600)", label: "aiWorkbench.faceSwapeCameraOptions.photography.iso.options.medium" },
          { key: "High ISO (3200-6400)", label: "aiWorkbench.faceSwapeCameraOptions.photography.iso.options.high" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeCameraOptions.photography.whiteBalance.label",
        key: "white_balance",
        options: [
          { key: "Auto", label: "aiWorkbench.faceSwapeCameraOptions.photography.whiteBalance.options.auto" },
          { key: "Daylight", label: "aiWorkbench.faceSwapeCameraOptions.photography.whiteBalance.options.daylight" },
          { key: "Cloudy", label: "aiWorkbench.faceSwapeCameraOptions.photography.whiteBalance.options.cloudy" },
          { key: "Tungsten", label: "aiWorkbench.faceSwapeCameraOptions.photography.whiteBalance.options.tungsten" },
          { key: "Fluorescent", label: "aiWorkbench.faceSwapeCameraOptions.photography.whiteBalance.options.fluorescent" },
          { key: "Custom", label: "aiWorkbench.faceSwapeCameraOptions.photography.whiteBalance.options.custom" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeCameraOptions.photography.focusMode.label",
        key: "focus_mode",
        options: [
          { key: "Single-point AF", label: "aiWorkbench.faceSwapeCameraOptions.photography.focusMode.options.singlePoint" },
          { key: "Zone AF", label: "aiWorkbench.faceSwapeCameraOptions.photography.focusMode.options.zone" },
          { key: "Auto AF", label: "aiWorkbench.faceSwapeCameraOptions.photography.focusMode.options.auto" },
          { key: "Face detection AF", label: "aiWorkbench.faceSwapeCameraOptions.photography.focusMode.options.faceDetection" },
          { key: "Tracking AF", label: "aiWorkbench.faceSwapeCameraOptions.photography.focusMode.options.tracking" },
          { key: "Manual focus", label: "aiWorkbench.faceSwapeCameraOptions.photography.focusMode.options.manual" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeCameraOptions.photography.exposureMode.label",
        key: "exposure_mode",
        options: [
          { key: "Auto exposure", label: "aiWorkbench.faceSwapeCameraOptions.photography.exposureMode.options.auto" },
          { key: "Shutter priority", label: "aiWorkbench.faceSwapeCameraOptions.photography.exposureMode.options.shutterPriority" },
          { key: "Aperture priority", label: "aiWorkbench.faceSwapeCameraOptions.photography.exposureMode.options.aperturePriority" },
          { key: "Manual exposure", label: "aiWorkbench.faceSwapeCameraOptions.photography.exposureMode.options.manual" },
          { key: "Exposure compensation", label: "aiWorkbench.faceSwapeCameraOptions.photography.exposureMode.options.compensation" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeCameraOptions.photography.shootingMode.label",
        key: "shooting_mode",
        options: [
          { key: "Single shot", label: "aiWorkbench.faceSwapeCameraOptions.photography.shootingMode.options.single" },
          { key: "Burst mode", label: "aiWorkbench.faceSwapeCameraOptions.photography.shootingMode.options.burst" },
          { key: "Time-lapse", label: "aiWorkbench.faceSwapeCameraOptions.photography.shootingMode.options.timeLapse" },
          { key: "Super slow-motion", label: "aiWorkbench.faceSwapeCameraOptions.photography.shootingMode.options.slowMotion" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeCameraOptions.photography.shootingAngle.label",
        key: "shooting_angle",
        options: [
          { key: "High angle (looking down)", label: "aiWorkbench.faceSwapeCameraOptions.photography.shootingAngle.options.high" },
          { key: "Low angle (looking up)", label: "aiWorkbench.faceSwapeCameraOptions.photography.shootingAngle.options.low" },
          { key: "Front view", label: "aiWorkbench.faceSwapeCameraOptions.photography.shootingAngle.options.front" },
          { key: "Side view", label: "aiWorkbench.faceSwapeCameraOptions.photography.shootingAngle.options.side" },
          { key: "45-degree angle", label: "aiWorkbench.faceSwapeCameraOptions.photography.shootingAngle.options.fortyFive" }
        ]
      },
      {
        name: "aiWorkbench.faceSwapeCameraOptions.photography.pose.label",
        key: "pose",
        options: [
          { key: "Power Pose", label: "aiWorkbench.faceSwapeCameraOptions.photography.pose.options.power" },
          { key: "Walking Pose", label: "aiWorkbench.faceSwapeCameraOptions.photography.pose.options.walking" },
          { key: "S-curve Pose", label: "aiWorkbench.faceSwapeCameraOptions.photography.pose.options.sCurve" },
          { key: "Sitting Pose", label: "aiWorkbench.faceSwapeCameraOptions.photography.pose.options.sitting" },
          { key: "Leaning Pose", label: "aiWorkbench.faceSwapeCameraOptions.photography.pose.options.leaning" },
          { key: "Headshot Pose", label: "aiWorkbench.faceSwapeCameraOptions.photography.pose.options.headshot" },
          { key: "Hand-on-Hip Pose", label: "aiWorkbench.faceSwapeCameraOptions.photography.pose.options.handOnHip" },
          { key: "Candid Laugh Pose", label: "aiWorkbench.faceSwapeCameraOptions.photography.pose.options.candidLaugh" },
          { key: "High Fashion Pose", label: "aiWorkbench.faceSwapeCameraOptions.photography.pose.options.highFashion" }
        ]
      }
    ]
  },
];

export default cameraOptions;